// AUTO-GENERATED from services/app-api-service/codeigniter/application/contracts/MensagensProgramadas_EditScheduledMessageResponse.php
// Do not edit by hand — edit the PHP ResponseContract and the sync hook will regenerate this file.
// Bulk regeneration: scripts/sync-contracts/sync-all.sh

/**
 * ResponseContract for editScheduledMessage() /mensagens_programadas/editScheduledMessage
 * Returns a success message after rescheduling a scheduled message.
 */
import type { ApiResponse } from '../services/httpService'
import { registerResponseContract } from './validate'

export interface MensagensProgramadas_EditScheduledMessageResponseDados {
message?: string
}

export type MensagensProgramadas_EditScheduledMessageResponse = ApiResponse<MensagensProgramadas_EditScheduledMessageResponseDados>;

registerResponseContract('MensagensProgramadas_EditScheduledMessageResponse', {
  message: { type: 'string',  required: false },
})
